<div class="gl-page">
  @if (isLoadingAny()) {
    <div class="cbr-loading-overlay">
      <yds-spinner size="lg" label="Gegevens laden..." />
    </div>
  }

  <div class="gl-page__header">
    <h1 class="gl-page__title">{{ title() }}</h1>
  </div>

  <yds-card>
    <div class="cbr-details">
      <h2 class="cbr-details__title">Details</h2>

      <div class="gl-list-toolbar__top">
        <div class="gl-list-toolbar__filter">
          <yds-dropdown
            label="Opdrachtgever"
            [items]="opdrachtgeverOptions()"
            [value]="opdrachtgeverId()"
            [allowClear]="false"
            [required]="true"
            [disabled]="isLoadingOpdrachtgevers()"
            (valueChange)="onOpdrachtgeverChange($event)"
          />
        </div>
        <div class="gl-list-toolbar__filter">
          <yds-dropdown
            label="Instelling"
            [items]="instellingOptions()"
            [value]="instellingId()"
            [allowClear]="false"
            [required]="true"
            [disabled]="isLoadingInstellingen() || instellingOptions().length === 0"
            (valueChange)="onInstellingChange($event)"
          />
        </div>
      </div>
    </div>

    <div class="gl-list-table">
      @if (!isLoadingList() && tableItems().length === 0) {
        <yds-empty-states message="Er zijn geen resultaten" />
      } @else if (!isLoadingList()) {
        <yds-table
          [embedded]="true"
          [showPaginationFooter]="importRuns().length > 0"
          [columns]="tableColumns()"
          [items]="tableItems()"
          [zebra]="true"
          [dottedColumns]="true"
          [clickable]="true"
          [selectedIds]="tableSelectedIds()"
          (rowClick)="onTableRowClick($event)"
          (rowDoubleClick)="onTableRowDoubleClick($event)"
        >
          <ng-template ydsTableCell="actions" let-item="item">
            <yds-split-button
              [label]="actionLabel()"
              [items]="splitButtonItems()"
              variant="default"
              size="sm"
              (keydown)="$event.stopPropagation()"
              (mainClick)="onRowActionClick(item.id, $event)"
              (itemClick)="onRowMenuItemClick(item.id, $event)"
            ></yds-split-button>
          </ng-template>

          @if (importRuns().length > 0) {
            <yds-pagination
              pagination
              [(pageIndex)]="pageIndex"
              [pageSize]="pageSize"
              [totalItems]="importRuns().length"
            />
          }
        </yds-table>
      }
    </div>

    @if (showFooterAction()) {
      <div class="cbr-footer">
        <yds-button variant="primary" [disabled]="!hasSelection()" (click)="onActionClick()">
          {{ actionLabel() }}
        </yds-button>
      </div>
    }
  </yds-card>
</div>
